import React from "react";

import { queryMetricsLabels } from "../../../../queries/metrics/labels";
import { useQuery } from "../../../../queries/react-query";
import { useFormTimeRange } from "../../_form-context";
import { LabelName } from "../_label-name";
import { SeriesSelectors } from "../_series-selectors";

import type { FormState } from "./_form-state";

export interface VariableFormProps {
	state: FormState;
}

export const VariableForm: React.FC<VariableFormProps> = ({ state }) => {
	const timeRange = useFormTimeRange();
	const { data = [] } = useQuery(queryMetricsLabels({ timeRange }));

	return (
		<>
			<LabelName state={state.fields.labelName} suggestions={data} />

			<SeriesSelectors state={state.fields.selectors} />
		</>
	);
};
